import { lazy } from 'react';

// ----------------------------------------------------------------------

const BranchesPage = lazy(() => import('../pages/Branches.page'));
const BranchesListPage = lazy(() => import('../pages/BranchesList.page'));
const AddBranchPage = lazy(() => import('../pages/AddBranch.page'));
const EditBranchPage = lazy(() => import('../pages/EditBranch.page'));

// ----------------------------------------------------------------------

const BranchesRoutes = [
    {
        path: '/branches',

        children: [
            { element: <BranchesPage />, layout: 'default', isAuthReq: true, index: true },
            { path: 'list', element: <BranchesListPage />, layout: 'default', isAuthReq: true },
            { path: 'add', element: <AddBranchPage />, layout: 'default', isAuthReq: true },
            { path: ':id/edit', element: <EditBranchPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { BranchesRoutes };
